import { render, staticRenderFns } from "./ViewCard.vue?vue&type=template&id=15a5bd05&"
import script from "./ViewCard.vue?vue&type=script&lang=js&"
export * from "./ViewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a5bd05')) {
      api.createRecord('15a5bd05', component.options)
    } else {
      api.reload('15a5bd05', component.options)
    }
    module.hot.accept("./ViewCard.vue?vue&type=template&id=15a5bd05&", function () {
      api.rerender('15a5bd05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ViewCard.vue"
export default component.exports